/* eslint-disable react/jsx-key */
import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';

import { ContainerStudies, ContainerLoading } from './style.js';
import Loading from '../../../assets/loading.json';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import InputDefault from '../../../components/InputDefault/index.js';
import ButtonAction from '../../../components/ButtonAction/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalEdit from '../../../components/Modals/ModalEdit/index.js';

const ConnectionTypeList = () => {
  document.title = 'Enermerco - Ligação';

  const [isLoading, setIsLoading] = useState(true);

  const [connectionTypeList, setConnectionTypeList] = useState([]);

  const [idDm012, setIdDm012] = useState('');
  const [connectionTypeName, setConnectionTypeName] = useState('');

  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalconnectionTypeDesc, setModalconnectionTypeDesc] = useState('');
  const [modalNumber1, setModalNumber1] = useState('');

  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: Loading
  };

  const applyFilter = (idDm012, connectionTypeName) => {
    console.log(idDm012, connectionTypeName);
    let url = 'connection_type?';
    if (idDm012 !== '') {
      url += `&id=${idDm012}`;
    }
    if (connectionTypeName !== '') {
      url += `&nome=${connectionTypeName}`;
    }
    api
      .get(url)
      .then((response) => {
        setConnectionTypeList(response.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchFilter = useCallback(() => {
    applyFilter(idDm012, connectionTypeName);
  }, [idDm012, connectionTypeName]);

  const cleanFields = useCallback(() => {
    setIdDm012('');
    setConnectionTypeName('');
    applyFilter('', '');
  }, [idDm012, connectionTypeName]);

  const deleteConnectionType = useCallback(
    (id) => {
      api
        .delete(`connection_type?id=${id}`)
        .then((response) => {
          setModalDelete(false);
          if (response.status === 200) {
            toast.success('Tipo de conexão removida com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          cleanFields();
          setModalDelete(false);
          toast.success(error);
        });
    },
    [modalDelete]
  );

  const addConnectionType = useCallback(
    (modalText, modalNumber1) => {
      api
        .post(`connection_type`, {
          NM_LIGACAO: modalText.toUpperCase(),
          VL_DISPONIBILIDADE: parseFloat(modalNumber1.replace(',', '.'))
        })
        .then((response) => {
          setModalAdd(false);
          if (response.status === 201) {
            toast.success('Conexão adicionada com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalAdd(false);
          toast.success(error);
        });
    },
    [modalAdd]
  );

  const editConectionType = useCallback(
    (modalText, modalNumber1, _modalNumber2, _modalNumber3, id, modalStatus) => {
      api
        .put(`connection_type?id=${id}`, {
          NM_LIGACAO: modalText.toUpperCase(),
          VL_DISPONIBILIDADE: parseFloat(modalNumber1.replace(',', '.'))
        })
        .then((response) => {
          setModalEdit(false);
          if (response.status === 201) {
            toast.success('Registro alterado com sucesso!');
          } else {
            toast.error(response.data.message);
          }
          cleanFields();
        })
        .catch((error) => {
          setModalEdit(false);
          toast.success(error);
        });
    },
    [modalEdit]
  );

  useEffect(() => {
    applyFilter(idDm012, connectionTypeName);
  }, []);

  return (
    <>
      <AuthGuard />
      <Menu />
      {isLoading ? (
        <ContainerLoading>
          <Lottie options={loadingAnimation} style={{ width: '100%', height: 400 }} />
          <h1>Carregando Tipos de Conexão...</h1>
        </ContainerLoading>
      ) : (
        <Container>
          <ContainerStudies>
            <h2>Lista de Tipos de Conexão</h2>
            <ButtonDefault
              Width={'150px'}
              Margin={'0px 30px 30px 0px'}
              Text="Adicionar"
              onClick={() => {
                setModalAdd(true);
              }}
            />
            <h3>Filtros</h3>
            <Row>
              <Col xs={3}>
                <InputDefault
                  placeholder="Código da Coexão"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Código'}
                  value={`${idDm012}`}
                  onChange={(e) => setIdDm012(e.target.value)}
                />
              </Col>
              <Col xs={6}>
                <InputDefault
                  placeholder="Nome da Conexão"
                  Width={'100%'}
                  Margin={'10px 0px 15px 0px'}
                  Text={'Nome'}
                  value={`${connectionTypeName}`}
                  onChange={(e) => setConnectionTypeName(e.target.value)}
                />
              </Col>
            </Row>
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Buscar"
              onClick={searchFilter}
            />
            <ButtonDefault
              Width={'150px'}
              Margin={'20px 30px 30px 0px'}
              Text="Limpar"
              onClick={() => {
                cleanFields();
              }}
            />
            <Table striped bordered hover variant="light">
              <thead>
                <tr>
                  <th style={{ width: '5%', textAlign: 'right' }}>Código</th>
                  <th style={{ width: '20%' }}>Nome da Conexão</th>
                  <th style={{ width: '20%', textAlign: 'right' }}>Disponibilidade</th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Ação</th>
                </tr>
              </thead>
              <tbody>
                {connectionTypeList.map((connectionType) => (
                  <tr>
                    <td style={{ textAlign: 'right' }}>{connectionType.ID_DM012}</td>
                    <td>{connectionType.NM_LIGACAO}</td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(connectionType.VL_DISPONIBILIDADE).toFixed(2).replace('.', ',')}
                    </td>

                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '45px',
                        justifyContent: 'center'
                      }}>
                      <ButtonAction
                        Action="Edit"
                        onClick={() => {
                          setIdDm012(connectionType.ID_DM012);
                          setModalconnectionTypeDesc(connectionType.NM_LIGACAO);
                          setModalNumber1(
                            Number(connectionType.VL_DISPONIBILIDADE).toFixed(2).replace('.', ',')
                          );
                          setModalEdit(true);
                        }}
                      />
                      <ButtonAction
                        Action="Remove"
                        onClick={() => {
                          setIdDm012(connectionType.ID_DM012);
                          setModalconnectionTypeDesc(connectionType.NM_LIGACAO);
                          setModalDelete(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ContainerStudies>
          <ToastContainer />
          <ModalDelete
            modalOpen={modalDelete}
            handleClose={() => setModalDelete(false)}
            handleConfirm={deleteConnectionType}
            handleCancel={() => setModalDelete(false)}
            modalTitleText={`Deseja excluir a Subclasse #${idDm012}?`}
            modalText={modalconnectionTypeDesc}
            id={idDm012}
          />
          <ModalAdd
            modalOpen={modalAdd}
            handleClose={() => setModalAdd(false)}
            handleConfirm={addConnectionType}
            handleCancel={() => setModalAdd(false)}
            modalTitleText={'Adicionar nova Conexão'}
            modalText={modalconnectionTypeDesc}
            visibleText={true}
            visibleNumber1={true}
            placeHolderText={'Nome'}
            textLabel={'Valor disponível'}
            number1Label={'Valor disponível'}
            placeHolderNumber1={'Valor disponível'}
          />
          <ModalEdit
            modalOpen={modalEdit}
            handleClose={() => setModalEdit(false)}
            handleConfirm={editConectionType}
            handleCancel={() => setModalEdit(false)}
            modalTitleText={`Editar Conexão #${idDm012}`}
            visibleText={true}
            visibleNumber1={true}
            textLabel={'Nome Conexão'}
            number1Label={'Valor disponível'}
            id={idDm012}
            setModalText={setModalconnectionTypeDesc}
            modalText={modalconnectionTypeDesc}
            modalNumber1={modalNumber1}
            setModalNumber1={setModalNumber1}
            modalNumber2={''}
            setModalNumber2={() => {}}
            modalNumber3={''}
            setModalNumber3={() => {}}
          />
          <Footer />
        </Container>
      )}
    </>
  );
};

export default ConnectionTypeList;
